(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["editorial-header"]) return;
  try {
    
if (!customElements.get('tc-navigation-drawer')) {
  customElements.define('tc-navigation-drawer', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = {signal:this.abort.signal};
      this.details = this.querySelector('.ed-menu');
      this.trigger = this.details?.querySelector('summary');
      const panel = this.querySelector('.tc-drawer-panel');
      if (!this.trigger || !panel) return;
      this.dialog = this.querySelector('dialog') || document.createElement('dialog');
      this.dialog.className = 'tc-drawer-modal';
      this.dialog.setAttribute('aria-label',this.dataset.dialogLabel);
      this.dialog.append(panel);
      this.append(this.dialog);
      this.trigger.setAttribute('aria-haspopup','dialog');
      this.trigger.setAttribute('aria-expanded','false');
      this.trigger.addEventListener('click', event => {
        event.preventDefault();
        this.previousOverflow = document.body.style.overflow;
        this.dialog.showModal();
        document.body.style.overflow = 'hidden';
        this.trigger.setAttribute('aria-expanded','true');
      },options);
      this.dialog.addEventListener('close', () => {
        document.body.style.overflow = this.previousOverflow || '';
        this.trigger.setAttribute('aria-expanded','false');
        this.trigger.focus({preventScroll:true});
      },options);
      this.dialog.addEventListener('click', event => {
        if (!(event.target instanceof Element)) return;
        if (event.target === this.dialog || event.target.closest('[data-tc-close]')) this.dialog.close();
        const tab = event.target.closest('[data-tc-tab]');
        if (tab) this.selectTab(tab);
      },options);
      this.dialog.addEventListener('keydown', event => {
        if (!(event.target instanceof Element)) return;
        const tab = event.target.closest('[data-tc-tab]');
        if (!tab || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        event.preventDefault();
        const tabs = [...this.querySelectorAll('[data-tc-tab]')];
        const next = tabs[event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (tabs.indexOf(tab) + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length];
        this.selectTab(next);
        next.focus();
      },options);
    }
    selectTab(selected) {
      for (const tab of this.querySelectorAll('[data-tc-tab]')) {
        const active = tab === selected;
        tab.setAttribute('aria-selected',String(active));
        tab.tabIndex = active ? 0 : -1;
      }
      for (const panel of this.querySelectorAll('[data-tc-panel]')) panel.hidden = panel.dataset.tcPanel !== selected.dataset.tcTab;
    }
    disconnectedCallback() {
      if (this.dialog?.open) {
        this.dialog.close();
        document.body.style.overflow = this.previousOverflow || '';
      }
      this.abort?.abort();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
